import { render, staticRenderFns } from "./AddShoeColor.vue?vue&type=template&id=1dcc949a&scoped=true&"
import script from "./AddShoeColor.vue?vue&type=script&lang=js&"
export * from "./AddShoeColor.vue?vue&type=script&lang=js&"
import style0 from "./AddShoeColor.vue?vue&type=style&index=0&id=1dcc949a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc949a",
  null
  
)

export default component.exports